import {ActionBuilder} from "@cuatroochenta/co-redux-builders";

export default ActionBuilder.build({
	dispatchSetCollectionCash: (id: string, cash: number) => ({id, cash}),
	dispatchClearReducer: () => ({})
})
